
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 25 25","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-stroke",attrs:{"id":"Rectangle","fill":"none","stroke":"#fff","stroke-width":"1","stroke-miterlimit":"5.556","d":"M2.5 2.5h20v20h-20z"}}),_c('circle',{staticClass:"st1",attrs:{"id":"Oval","cx":"7.4","cy":"7.6","r":"1.9","fill":"#FFF"}}),_c('circle',{staticClass:"st1",attrs:{"id":"Oval-Copy","cx":"12.6","cy":"12.5","r":"1.9","fill":"#FFF"}}),_c('circle',{staticClass:"st1",attrs:{"id":"Oval-Copy-2","cx":"17.6","cy":"17.4","r":"1.9","fill":"#FFF"}})])
          )
        }
      }
    